import React from "react";
import { ThemeContext } from "../../ContextProvider/ThemeContextProvider";
import ToggleSwitch from "../../Utils/ToggleSwitch/ToggleSwitch";
import {
  SidebarContainer,
  Icon,
  CloseIcon,
  SidebarMenu,
  SidebarWrapper,
  SidebarLink,
  ToggleWrapper,
} from "./SidebarElement";

const Sidebar = () => {
  const { isOpen, handleOpen, mode } = React.useContext(ThemeContext);
  return (
    <SidebarContainer isOpen={isOpen} onClick={handleOpen}>
      <Icon theme={mode} onClick={handleOpen}>
        <CloseIcon style={{ color: "rgb(109, 131, 242)" }} />
      </Icon>
      <SidebarWrapper>
        <SidebarMenu>
          <SidebarLink to="#home" onClick={handleOpen}>
            Home
          </SidebarLink>
          <SidebarLink href="#about" onClick={handleOpen}>
            About
          </SidebarLink>
          <SidebarLink href="#skills" onClick={handleOpen}>
            Skills
          </SidebarLink>
          <SidebarLink href="#experience" onClick={handleOpen}>
            Experience
          </SidebarLink>
          <SidebarLink href="#projects" onClick={handleOpen}>
            Projects
          </SidebarLink>
          <SidebarLink href="#contact" onClick={handleOpen}>
            Contact
          </SidebarLink>
        </SidebarMenu>
        <ToggleWrapper>
          <ToggleSwitch />
        </ToggleWrapper>
      </SidebarWrapper>
    </SidebarContainer>
  );
};

export default Sidebar;
